import { watch } from 'vue'
import { nonNull } from 'commons-mathrail/shared/fns'
import { persistentSettings } from './local-storage'
import { sceneId } from '../scene/scene-state'

watch(() => persistentSettings.value.sound, () => {
  if (!persistentSettings.value.sound) {
    cancelSpeaking()
  }
})

const { speechSynthesis, SpeechSynthesisUtterance } = window

const names = {
  en: ['Aaron', 'Daniel'],
  cs: ['Zuzana'],
  nl: ['Ellen'],
  pl: ['Zosia']
}
let voice
let voiceLocale

export const getVoice = locale => {
  if (!voice || locale !== voiceLocale) {
    const localeNames = names[locale] ?? names.en
    const findVoice = predicate => speechSynthesis.getVoices().find(predicate)
    voice =
      localeNames
        .map(name => findVoice(v => v.name === name))
        .find(nonNull) ?? // find by name
      findVoice(v => v.lang.includes(locale)) // fallback to first for the locale
    voiceLocale = locale
  }
  return voice
}

export const speak = (locale, text) => {
  // console.log('Speak', locale, text)
  if (locale && text && persistentSettings.value.sound && sceneId.value != null) {
    cancelSpeaking()
    const utterance = new SpeechSynthesisUtterance(text)
    utterance.voice = getVoice(locale)
    speechSynthesis.speak(utterance)
  }
}

export const cancelSpeaking = () => {
  speechSynthesis.cancel()
}
